import { InvestmentService } from "@/services";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { safeMoment } from "@/utils/safeMoment";
import parseHttpError from "@/utils/parseHttpError";

const Updates = ({ investmentId }: { investmentId: string }) => {
  const [investmentUpdates, setInvestmentUpdates] = useState<any>([]);

  const getInvestmentUpdates = async () => {
    try {
      const response =
        await InvestmentService.GetInvestmentUpdates(investmentId);
      return response?.data;
    } catch (error: any) {
      console.log(error);
      throw new Error(parseHttpError(error).message);
    }
  };

  const {
    data: investmentUpdatesData,
    isLoading: investmentUpdatesIsLoading,
    isError: investmentUpdatesIsError,
    refetch: investmentUpdatesRefetch,
    isSuccess: investmentUpdatesIsSuccess,
  } = useQuery({
    queryKey: ["investmentUpdates", investmentId],
    queryFn: getInvestmentUpdates,
    staleTime: 0,
    enabled: !!investmentId,
  });

  useEffect(() => {
    if (investmentUpdatesData) {
      setInvestmentUpdates(investmentUpdatesData?.data);
    }
  }, [investmentUpdatesData]);

  return (
    <div className="bg-white p-6">
      {/* <h3 className="text-lg font-bold mb-4">Updates</h3> */}
      {investmentUpdatesIsLoading ? (
        <div>Loading...</div>
      ) : investmentUpdatesIsError ? (
        <div>Error fetching updates</div>
      ) : investmentUpdates.length === 0 ? (
        <div>No updates yet</div>
      ) : (
        <ul className="flex flex-col">
          {investmentUpdates.map((update: any, index: number) => (
            <li key={index} className="flex items-center  gap-2">
              <div className="flex flex-col justify-center">
                <div className=" w-[18px] h-[18px] rounded-full bg-[#2D96A7]"></div>
                <div className="flex flex-col gap-4 relative pl-6 border-l-2 border-bnp-cyan h-12 ml-2"></div>
              </div>

              <div className="text-gray-500 text-sm -mt-10">
                {update.action === "SUBSCRIBER_ADDED"
                  ? "NEW SUBSCRIBER ADDED"
                  : update.action}{" "}
                {update.action === "CREATED" && "by"} {update.owner} on{" "}
                {safeMoment(update.timestamp)?.format("MMM D, YYYY h:mm A") ??
                  "-"}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Updates;
